export const EXPRESS_DESIGNER_TRACKING_ACTION = 'ExpressProdukt';

export const EXPRESS_DESIGNER_TRACKING_LABELS = {
  INIT: 'Start',
  UPLOAD_PHOTO: 'Fotoupload',
  ADD_TO_CART: 'Warenkorb - ',
  SHOW_PRODUCT_DETAILS: 'Produktdetails - ',
} as const;
